import { Calculator, CheckCircle, ShoppingCart, X } from "lucide-react";
import React from "react";

const PaymentSection = React.memo(({ 
  selectedQuotas, 
  pendingQuotas,
  isCalculated, 
  calculatedTotal, 
  areSetsEqual,
  lastCalculatedQuotas,
  handleCalculatePayment,
  handlePayment,
  handleSelectAll,
  handleDeselectAll,
  formatCurrency,
  userRole
}) => {
  const allPendingSelected = pendingQuotas.length > 0 && 
    pendingQuotas.every(quota => selectedQuotas.has(quota.id));
  
  return (
    <div className="space-y-4 mb-6 p-4 bg-blue-50 rounded-xl border border-blue-200">
      {/* Botones de selección */}
      <div className="flex flex-wrap items-center gap-2">
        <button
          onClick={handleSelectAll}
          disabled={pendingQuotas.length === 0 || allPendingSelected}
          className="flex items-center gap-2 px-3 py-1.5 text-sm bg-purple-500 text-white rounded-md hover:bg-purple-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          <CheckCircle size={14} />
          Seleccionar Todo ({pendingQuotas.length})
        </button>
        
        <button
          onClick={handleDeselectAll}
          disabled={selectedQuotas.size === 0}
          className="flex items-center gap-2 px-3 py-1.5 text-sm bg-gray-500 text-white rounded-md hover:bg-gray-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          <X size={14} />
          Deseleccionar Todo
        </button>
      </div>

      {/* Botones de pago */}
      <div className="flex flex-wrap items-center gap-4">
        <button
          onClick={handleCalculatePayment}
          disabled={selectedQuotas.size === 0}
          className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          <Calculator size={16} />
          Calcular Pago ({selectedQuotas.size} cuotas)
        </button>
        
        {userRole === 'socio' &&
        <button
          onClick={handlePayment}
          disabled={!isCalculated || selectedQuotas.size === 0 || !areSetsEqual(selectedQuotas, lastCalculatedQuotas)}
          className="flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          <ShoppingCart size={16} />
          Pagar {isCalculated ? formatCurrency(calculatedTotal) : ''}
        </button>
        }
      </div>
      
      {isCalculated && (
        <div className="text-sm text-gray-600">
          <span className="font-medium">Total calculado:</span> 
          <span className="text-green-600 font-bold ml-1">{formatCurrency(calculatedTotal)}</span>
          {!areSetsEqual(selectedQuotas, lastCalculatedQuotas) && (
            <span className="text-orange-600 ml-2">(Recalcular requerido)</span>
          )}
        </div>
      )}
    </div>
  );
});

export default PaymentSection;